import { render, staticRenderFns } from "./ZomatoGo.vue?vue&type=template&id=3a626ec4&scoped=true&"
import script from "./ZomatoGo.vue?vue&type=script&lang=js&"
export * from "./ZomatoGo.vue?vue&type=script&lang=js&"
import style0 from "./ZomatoGo.vue?vue&type=style&index=0&id=3a626ec4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a626ec4",
  null
  
)

export default component.exports